import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import AddonManagementHeader from './AddonManagementHeader';
import AddonManagementLabel from './AddonManagementLabel';
import useSelectedCompany from '../../hooks/useSelectedCompany';
import useCompanyOptions from '../../hooks/useCompanyOptions';
import AddonList from './AddonList';
import GlobalAddonSettings from './GlobalAddonSettings';
import { useGetAddonsQuery } from '../../services/api';

const AddonManagement = () => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const { companyOptions } = useCompanyOptions();
    const { selectedCompany, selectedCompanyId, handleCompanyChange, getSelectedCompanyLabel } = useSelectedCompany({ companyOptions });

    const { data: addonData = [] } = useGetAddonsQuery(selectedCompanyId, { skip: !selectedCompanyId });

    const [tabValue, setTabValue] = useState('global');

    return (
        <Box m={isSmallScreen ? '1rem' : '1rem 2.5rem'}>
            <AddonManagementHeader isSmallScreen={isSmallScreen} selectedCompany={selectedCompany} handleCompanyChange={handleCompanyChange} companyOptions={companyOptions} />

            <AddonManagementLabel selectedCompany={selectedCompany} isSmallScreen={isSmallScreen} tabValue={tabValue} setTabValue={setTabValue} getSelectedCompanyLabel={getSelectedCompanyLabel()} />

            {tabValue === 'device' ? <AddonList addonData={addonData} theme={theme} isSmallScreen={isSmallScreen} /> : <GlobalAddonSettings selectedCompanyId={selectedCompanyId} />}
        </Box>
    );
};

export default AddonManagement;
